<template>
  <DefaultLayout v-show="render">
    <router-view></router-view>
  </DefaultLayout>
  <div v-show="excelLoader || pdfLoader" class="blockUI" style="display:none"></div>
  <div v-show="excelLoader || pdfLoader" class="blockUI blockOverlay"
       style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
  <div v-show="excelLoader || pdfLoader" class="blockUI blockMsg blockPage"
       style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
    <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait while you request is being processed...</p>
      <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
    </div>
  </div>
  <LogoutByNoti
    :show="logoutPopup"
    @logout="hideLogoutPopup"
  />
</template>

<script>

import LogoutByNoti from "../../components/auth/logout/LogoutByNoti";
import {mapState} from "vuex";

export default {
  components:{
    LogoutByNoti
  },
  computed:{
    ...mapState(['excelLoader','pdfLoader','logoutPopup']),
  },
  data() {
    return {
     render:false,
    }
  },
  beforeCreate() {
    document.querySelector("#app").style["display"] = 'none'
  },
  beforeMount(){
    let featureList = this.$store.getters.getDashboardFeatures
    if(featureList){
      this.render = true
      document.querySelector("#app").removeAttribute('style');
      return
    }
    this.makeRequest('post', 'v1/get-dashboard-feature-list', {}, {}, false,false).then(callResponse => {

      if (!callResponse.error) {
        let code = callResponse.response.data.code;

        if (code == 200) {
          this.$store.commit('setDashboardFeatures', callResponse.response.data.data);
          this.render = true
        }else{
          this.$router.push({name: 'send-otp'});
        }
        document.querySelector("#app").removeAttribute('style');
      }
    });

    // var urlArray=['app-assets/vendors/js/vendors.min.js','app-assets/js/core/app-menu.js','app-assets/js/core/app.js']
    // for (let i = 0; i<3 ;i++){
    //   let scriptUrl = this.publicPath + urlArray[i]
    //   if(!this.isLoadedScript(scriptUrl)){
    //     const plugin = document.createElement("script");
    //     plugin.setAttribute(
    //         "src",
    //         scriptUrl
    //     );
    //     plugin.defer = true;
    //     document.body.appendChild(plugin);
    //   }
    //
    // }

  },
  mounted() {

  },
  methods:{
    isLoadedScript(lib) {
      return document.querySelectorAll('[src="' + lib + '"]').length > 0
    },
    hideLogoutPopup(){
      this.$store.dispatch('showLogoutPopup',false)
      this.$router.push({name:'send-otp'})
    }
  }

}
</script>

